import { render, staticRenderFns } from "./basicDashboard.vue?vue&type=template&id=0edd9240&scoped=true&"
import script from "./basicDashboard.vue?vue&type=script&lang=js&"
export * from "./basicDashboard.vue?vue&type=script&lang=js&"
import style0 from "./basicDashboard.vue?vue&type=style&index=0&id=0edd9240&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edd9240",
  null
  
)

export default component.exports